export default __webpack_public_path__ + "static/media/warehouse.df42f9e9.svg";